import Vue from "vue";
import Vuex from "vuex";

import { auth, db } from "@/firebase";
import router from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    noticias: [],
    reportes: [],
    reporte: {},
    noticia: {},
    usuario: {
      admin: false,
    },
    pregunta: {
      numeroPregunta: "",
      pregunta: "",
      respuestaA: "",
      respuestaB: "",
      respuestaC: "",
      respuestaD: "",
      respuestaCorrecta: "",
    },
    preguntaEdited: {},
    preguntas: [],
    testsIncompleted: [],
    tema: {},
    temas: [],
    test: {},
    tests: [],

    cliente: {
      nombre: "",
      apellidos: "",
      dni: "",
      telefono: "",
      email: "",
      fechaNacimiento: "",
    },
    clientes: [],
    texto: "",
    factura: {
      numFactura: "",
      dniCliente: "",
      totalFactura: "",
    },
    lineaFactura: {
      concepto: "",
      unidades: "",
      precioUnidad: "",
      precioTotal: "",
    },
    facturas: [],
    lineas: [],
    exist: false,
  },
  mutations: {
    setUsuario(state, payload) {
      state.usuario = payload;
    },

    nuevoUsuario(state, payload) {
      console.log("dentro nuevoUsuario");
      console.log(payload);
      if (payload === null) {
        console.log("usuario vacio");
        state.usuario = null;
      } else {
        state.usuario = payload;
      }
    },
    setClientes(state, clientes) {
      state.clientes = clientes;
    },
    setCliente(state, cliente) {
      state.cliente = cliente;
    },
    setFacturas(state, facturas) {
      state.facturas = facturas;
    },
    setLineas(state, lineas) {
      state.lineas = lineas;
    },
    setFactura(state, factura) {
      state.factura = factura;
    },
    cargarFirebase(state, payload) {
      state.loading = payload;
    },
    setEntradas(state, payload) {
      state.entradas = payload;
    },
    setComentarios(state, payload) {
      state.comentarios = payload;
    },
    setEntrada(state, payload) {
      state.entrada = payload;
    },
    setComentario(state, payload) {
      state.comentario = payload;
    },
    setJefes(state, payload) {
      state.jefes = payload;
    },
    setJefe(state, payload) {
      state.jefe = payload;
    },
    setPreguntaEdit(state, payload) {
      state.preguntaEdited = payload;
    },
    setPreguntas(state, preguntas) {
      state.preguntas = preguntas;
    },
    addPreguntas(state, preguntas) {
      state.preguntas.push(preguntas);
    },
    setTestsIncompleted(state, testsIncompleted) {
      state.testsIncompleted = testsIncompleted;
    },
    setPreguntasAgregar(state, preguntas) {
      preguntas.forEach((element) => {
        state.preguntas.push(element);
      });
      console.log("preguntas desde store");
      console.log(state.preguntas);
    },
    setTemas(state, temas) {
      state.temas = temas;
    },
    setNoticias(state, noticias) {
      state.noticias = noticias;
    },
    setReportes(state, reportes) {
      state.reportes = reportes;
    },
    setTests(state, tests) {
      state.tests = tests;
    },
    addTema(state, payload) {
      state.temas.push(payload);
    },
    addNoticia(state, payload) {
      state.noticias.push(payload);
    },
    addTest(state, payload) {
      state.tests.push(payload);
    },
    addPreguntaRandom(state, payload) {
      state.preguntas.push(payload);
      state.preguntas = state.preguntas
        .map((a) => ({ sort: Math.random(), value: a }))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value);
    },
    shufflePreguntas(state, payload) {
      state.preguntas.sort(() => 0.5 - Math.random());
      if (payload != null) {
        state.preguntas = state.preguntas.slice(0, payload);
      }
    },

    addPregunta(state, payload) {
      state.preguntas.push(payload);
    },
    addTestIncompleted(state, payload) {
      state.testsIncompleted.push(payload);
    },
    setExist(state, payload) {
      state.exist = payload;
    },
    deleteTemaMutate(state, payload) {
      state.temas = state.temas.filter((e) => {
        console.log("e.numeroTema " + e.numeroTema);
        console.log("payload " + payload);
        console.log(e.numeroTema == payload);
        return e.numeroTema != payload;
      });
    },
    deleteTestMutate(state, payload) {
      state.tests = state.tests.filter((e) => {
        console.log("e.id " + e.id);
        console.log("payload " + payload);
        console.log(e.id == payload);
        return e.id != payload;
      });
    },
    deleteTestIncompletedMutate(state, payload) {
      state.testsIncompleted = state.testsIncompleted.filter((e) => {
        return e.id != payload;
      });
    },
    deleteNoticiaMutate(state, payload) {
      state.noticias = state.noticias.filter((e) => {
        console.log("e.id " + e.id);
        console.log("payload " + payload);
        console.log(e.id == payload);
        return e.id != payload;
      });
    },
    deleteReportMutate(state, payload) {
      state.reportes = state.reportes.filter((e) => {
        console.log("e.id " + e.id);
        console.log("payload " + payload);
        console.log(e.id == payload);
        return e.id != payload;
      });
    },
    deletePreguntaMutate(state, payload) {
      state.preguntas = state.preguntas.filter((e) => {
        return e.id != payload;
      });
    },
    setClearPreguntas(state) {
      state.preguntas = [];
    },
  },
  actions: {
    cerrarSesion({ commit }) {
      auth.signOut();
      commit("nuevoUsuario", null);
      router.push({ name: "login" });
    },
    setPreguntas({ commit }, data) {
      commit("setPreguntas", data);
    },
    async setUsuario({ commit }, user) {
      console.log("Dentro setUsuario");
      console.log(user);
      try {
        const doc = await db.collection("usuario").doc(user.uid).get();

        if (doc.exists) {
          console.log("doc.exist");
          console.log(doc.data());
          commit("nuevoUsuario", doc.data());
        } else {
          const usuario = {
            nombre: user.displayName,
            email: user.email,
            uid: user.uid,
            foto: user.photoURL,
            admin: false,
          };
          await db.collection("usuario").doc(usuario.uid).set(usuario);

          console.log("usuario guardado en DB");
          commit("nuevoUsuario", usuario);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async editUsuario({ commit }, user) {
      console.log("Dentro setUsuario");
      console.log(user);
      try {
        const doc = await db
          .collection("usuario")
          .doc(user.uid)
          .set(user)
          .then((doc) => {
            console.log(doc);
          });

        commit("nuevoUsuario", user);
      } catch (error) {
        console.log(error);
      }
    },
    async enviarReporte({ commit }, reporte) {
      try {
        const testsCollection = db.collection("tests");
        const testRef = await testsCollection
          .where("numeroTema", "==", reporte.numeroTema)
          .where("nombreTest", "==", reporte.nombreTest)
          .get();
        console.log(testRef);
        for (const doc of testRef.docs) {
          const preguntaRef = await doc.ref
            .collection("preguntas")
            .doc(reporte.id)
            .get();

          console.log("2");
          console.log(preguntaRef);
          reporte.path = preguntaRef.ref.path;
        }

        // await testRef.get().then((snapshot) => {
        //   snapshot.forEach((doc) => {
        //     console.log("id test nuevo" + doc.id);
        //     console.log(doc.ref.path);

        //     })

        //   });

        // });
      } catch (error) {
        console.log(error);
      }

      console.log("Dentro enviarReporte");
      console.log(reporte);

      try {
        db.collection("reportes")
          .doc()
          .set(reporte)
          .then((doc) => {
            // router.push({name: 'home'})
            console.log(doc);
            commit("cargarFirebase", false);
          });
      } catch (error) {
        console.log(error);
      }
    },
    crearUsuario({ commit }, payload) {
      console.log("crearUsuario");
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.pass)
        .then((res) => {
          console.log(res.user.email);
          console.log(res.user.uid);
          commit("setUsuario", { email: res.user.email, uid: res.user.uid });

          // Crear una colección
          db.collection(res.user.email)
            .add({
              nombre: "Tarea de ejemplo",
            })
            .then(() => {
              router.push({ name: "home" });
            });
        });
    },
    ingresoUsuario({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.pass)
        .then((res) => {
          console.log(res);
          commit("setUsuario", { email: res.user.email, uid: res.user.uid });
          router.push({ name: "home" });
        })
        .catch((err) => {
          console.log(err);
          commit("setError", err.message);
        });
    },
    detectarUsuario({ commit }, payload) {
      if (payload != null) {
        commit("setUsuario", { email: payload.email, uid: payload.uid });
      } else {
        commit("setUsuario", null);
      }
    },

    loadNoticias({ commit }) {
      commit("cargarFirebase", true);
      setTimeout(() => {}, 5000);
      console.log("despues de time out");
      const noticias = [];
      db.collection("noticias")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id noticias" + doc.id);
            console.log(doc.data());
            let noticia = doc.data();
            noticia.id = doc.id;
            noticias.push(noticia);
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setNoticias", noticias);
    },
    loadReportes({ commit }) {
      console.log("loadReportes");
      commit("cargarFirebase", true);
      setTimeout(() => {}, 5000);
      console.log("despues de time out");
      const reportes = [];
      db.collection("reportes")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id reporte" + doc.id);
            console.log(doc.data());
            let reporte = doc.data();
            reporte.id = doc.id;
            reportes.push(reporte);
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setReportes", reportes);
    },
    loadTemas({ commit }) {
      commit("cargarFirebase", true);

      const temas = [];
      db.collection("temas")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id tema " + doc.id);
            console.log(doc.data());
            let tema = doc.data();
            tema.id = doc.id;
            temas.push(tema);
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setTemas", temas);
    },
    // para borrar
    loadTema({ commit }, id) {
      db.collection("temas")
        .doc(id)
        .get()
        .then((tema) => {
          console.log("tema cargado");
          console.log(tema);
        });
    },
    loadTests({ commit }) {
      commit("cargarFirebase", true);

      const tests = [];
      db.collection("tests")
        .orderBy("numeroTest", "asc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc.data());
            let test = doc.data();
            test.id = doc.id;
            tests.push(test);
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setTests", tests);
    },
    loadTestsPorTema({ commit }, id) {
      commit("cargarFirebase", true);

      var testsRef = db.collection("tests");

      var query = testsRef.where("tema", "==", id);

      const tests = [];

      query.get().then((snapshot) => {
        snapshot.forEach((doc) => {
          console.log("id" + doc.id);
          console.log(doc.data());
          let test = doc.data();
          test.id = doc.id;
          tests.push(test);
        });
        setTimeout(() => {
          commit("cargarFirebase", false);
        }, 0);
      });
    },

    clearPreguntas({ commit }) {
      commit("setClearPreguntas");
    },

    loadPreguntasPorTest({ commit }, numeroTest) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      const preguntas = [];
      db.collection("tests")
        .where("numeroTest", "==", numeroTest)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("preguntas"));
            doc.ref
              .collection("preguntas")
              .get()
              .then((preguntaSnap) => {
                preguntaSnap.forEach((item) => {
                  console.log(item.data());
                  let pregunta = item.data();
                  pregunta.id = item.id;
                  console.log("respuestas");
                  console.log(item);
                  console.log(pregunta);
                  if (pregunta.shuffle) {
                    pregunta.respuestas = pregunta.respuestas
                      .map((a) => ({ sort: Math.random(), value: a }))
                      .sort((a, b) => a.sort - b.sort)
                      .map((a) => a.value);
                  }
                  preguntas.push(pregunta);
                });
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setPreguntas", preguntas);
    },
    async loadPreguntaPorPath({ commit }, path) {
      commit("cargarFirebase", true);

      const pregunta = await db.doc(path).get();
      commit("setPreguntaEdit", pregunta.data());

      commit("cargarFirebase", false);
    },

    async savePreguntaEdited({ commit }, path) {
      commit("cargarFirebase", true);

      if (this.state.preguntaEdited.respuestaCorrecta == "A") {
        this.state.preguntaEdited.respuestas[0].correcta = true;
        this.state.preguntaEdited.respuestas[1].correcta = false;
        this.state.preguntaEdited.respuestas[2].correcta = false;
        this.state.preguntaEdited.respuestas[3].correcta = false;
      }
      if (this.state.preguntaEdited.respuestaCorrecta == "B") {
        this.state.preguntaEdited.respuestas[0].correcta = false;
        this.state.preguntaEdited.respuestas[1].correcta = true;
        this.state.preguntaEdited.respuestas[2].correcta = false;
        this.state.preguntaEdited.respuestas[3].correcta = false;
      }
      if (this.state.preguntaEdited.respuestaCorrecta == "C") {
        this.state.preguntaEdited.respuestas[0].correcta = false;
        this.state.preguntaEdited.respuestas[1].correcta = false;
        this.state.preguntaEdited.respuestas[2].correcta = true;
        this.state.preguntaEdited.respuestas[3].correcta = false;
      }
      if (this.state.preguntaEdited.respuestaCorrecta == "D") {
        this.state.preguntaEdited.respuestas[0].correcta = false;
        this.state.preguntaEdited.respuestas[1].correcta = false;
        this.state.preguntaEdited.respuestas[2].correcta = false;
        this.state.preguntaEdited.respuestas[3].correcta = true;
      }

      const pregunta = await db
        .doc(path)
        .set(this.state.preguntaEdited)
        .then((doc) => {
          console.log("preguntaEditada");
          console.log(doc);
          commit("cargarFirebase", false);
          commit("setPreguntaEdit", {});
        });
    },
    loadPreguntasPorTestExamen({ commit }, { numeroTest, numeroPreguntas }) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");
      console.log("loadPreguntasPorTestExamen");
      const preguntas = [];
      db.collection("tests")
        .where("numeroTest", "==", numeroTest)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("preguntas"));
            doc.ref
              .collection("preguntas")
              .get()
              .then((preguntaSnap) => {
                preguntaSnap.forEach((item) => {
                  console.log(item.data());
                  let pregunta = item.data();
                  pregunta.id = item.id;
                  console.log("respuestas");
                  console.log(pregunta.respuestas);
                  if (pregunta.shuffle) {
                    pregunta.respuestas = pregunta.respuestas
                      .map((a) => ({ sort: Math.random(), value: a }))
                      .sort((a, b) => a.sort - b.sort)
                      .map((a) => a.value);
                  }

                  preguntas.push(pregunta);
                });
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setPreguntas", preguntas.slice(0, numeroPreguntas));
    },

   
    async loadPreguntasPorTestsExamen(
      { commit },
      { testsSelected, numeroPreguntas, porcentajesSelected }
    ) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      // console.log("loadPreguntasPorTestsExamen");
      // console.log("numero Preguntas " + numeroPreguntas);
      var startTime, endTime;

  startTime = new Date();



      const preguntas = [];

      var porcentajeTotal = porcentajesSelected;

      // for (const test of testsSelected) {
      //   const testsRef = db.collection("tests").doc(test);
      //   const testDoc = await testsRef.get();
      //     porcentajeTotal += testDoc.data().porcentajeTest;
      //     // console.log("Tema " + testDoc.data().numeroTema)
      //     // console.log("Porcentaje Test " + testDoc.data().porcentajeTest);
        
      // }

      endTime = new Date();
      var timeDiff = endTime - startTime; //in ms
      // strip the ms
      timeDiff /= 1000;
    
      // get seconds 
      var seconds = Math.round(timeDiff);
      console.log(seconds + " seconds primera parte");
      console.log("Porcentaje total in Store " + porcentajesSelected )

      // console.log("Porcentaje Total")
    //  console.log(porcentajeTotal);


      // const testsRef = db
      //   .collection("tests")
      //   .where("id", "in", testsSelected);

      // const testsDoc = await testsRef.get();

      // console.log("testsDoc");
      // console.log(testsDoc);

      for (const test of testsSelected) {
        const testsRef = db.collection("tests").doc(test.id);
        const testDoc = await testsRef.get();

        // console.log("id tema " + testDoc.id);
        // console.log(testDoc.data());
        // console.log(testDoc.ref.collection("preguntas"));
      

        const preguntasPorTest = ((testDoc.data().porcentajeTest*100) / porcentajeTotal) * numeroPreguntas
        // console.log("Preguntas por test")
        // console.log(Math.ceil((preguntasPorTest/100) == 0) ?  1 :  Math.ceil(preguntasPorTest/100))
        // console.log(preguntasPorTest)
        // console.log("testsSelected.length")
        // console.log(testsSelected.length)

        const preguntasRef = null;

        if (testsSelected.length == 1){
          preguntasRef = testDoc.ref.collection("preguntas").limit(numeroPreguntas);
        }else{
          preguntasRef = testDoc.ref.collection("preguntas").limit(Math.ceil((preguntasPorTest/100) == 0) ?  1 : Math.ceil(preguntasPorTest/100));

        }
        const preguntasDoc = await preguntasRef.get();
        // console.log("Preguntas cargadas con limit")
        // console.log(preguntasDoc.docs)
        for (const item of preguntasDoc.docs) {
          let pregunta = item.data();
          
          pregunta.id = item.id;
          if (pregunta.shuffle) {
            pregunta.respuestas = pregunta.respuestas
              .map((a) => ({ sort: Math.random(), value: a }))
              .sort((a, b) => a.sort - b.sort)
              .map((a) => a.value);
          }
          preguntas.push(pregunta);
        }
      }
      const shuffled = preguntas.sort(() => 0.5 - Math.random());

      commit("setPreguntas", shuffled.slice(0, numeroPreguntas));
      setTimeout(() => {
        commit("cargarFirebase", false);
      }, 0);
      endTime = new Date();
      var timeDiff = endTime - startTime; //in ms
      // strip the ms
      timeDiff /= 1000;
    
      // get seconds 
      var seconds = Math.round(timeDiff);
      console.log(seconds + " seconds segunda parte");
    },
    
   

    //16/07/2022 cambio por cargar tests por ID
    async loadPreguntasPorTestsExamenViejo(
      { commit },
      { testsSelected, numeroPreguntas, porcentajesSelected }
    ) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      console.log("loadPreguntasPorTestsExamen");
      console.log("numero Preguntas " + numeroPreguntas);
      const preguntas = [];
      const testsNuevo = [];
      await testsSelected.forEach((element) => {
        console.log("numero de Test dentro for each ");
        console.log(element.split(",")[0]);
        console.log("numero de Tema dentro for each ");
        console.log(element.split(",")[1]);
        testsNuevo.push(parseInt(element.split(",")[0]));
      });

      console.log("testsNuevo");
      console.log(testsNuevo);

      const testsRef = db
        .collection("tests")
        .where("numeroTest", "in", testsNuevo);

      const testsDoc = await testsRef.get();

      console.log("testsDoc");
      console.log(testsDoc);

      for (const doc of testsDoc.docs) {
        console.log("id tema " + doc.id);
        console.log(doc);
        console.log(doc.ref.collection("preguntas"));
        const preguntasRef = doc.ref.collection("preguntas");
        const preguntasDoc = await preguntasRef.get();
        for (const item of preguntasDoc.docs) {
          let pregunta = item.data();
          pregunta.id = item.id;
          if (pregunta.shuffle) {
            pregunta.respuestas = pregunta.respuestas
              .map((a) => ({ sort: Math.random(), value: a }))
              .sort((a, b) => a.sort - b.sort)
              .map((a) => a.value);
          }
          preguntas.push(pregunta);
        }
      }
      const shuffled = preguntas.sort(() => 0.5 - Math.random());

      commit("setPreguntas", shuffled.slice(0, numeroPreguntas));
      setTimeout(() => {
        commit("cargarFirebase", false);
      }, 0);
    },
    async loadPreguntasPorTestsExamenBackup({ commit }, testsSelected) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      console.log("loadPreguntasPorTestsExamen");
      const preguntas = [];
      await testsSelected.forEach((element) => {
        console.log("numero de Test dentro for each ");
        console.log(element.split(",")[0]);
        console.log("numero de Tema dentro for each ");
        console.log(element.split(",")[1]);

        db.collection("tests")
          .where("numeroTest", "==", parseInt(element.split(",")[0], 10))
          .where("numeroTema", "==", element.split(",")[1])
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              console.log("id" + doc.id);
              console.log(doc);
              console.log(doc.ref.collection("preguntas"));
              doc.ref
                .collection("preguntas")
                .get()
                .then((preguntaSnap) => {
                  preguntaSnap.forEach((item) => {
                    console.log(item.data());
                    let pregunta = item.data();
                    pregunta.id = item.id;
                    console.log("respuestas");
                    console.log(pregunta.respuestas);
                    if (pregunta.shuffle) {
                      pregunta.respuestas = pregunta.respuestas
                        .map((a) => ({ sort: Math.random(), value: a }))
                        .sort((a, b) => a.sort - b.sort)
                        .map((a) => a.value);
                    }
                    preguntas.push(pregunta);
                    commit("addPreguntaRandom", pregunta);
                  });
                });
            });
            setTimeout(() => {
              commit("cargarFirebase", false);
            }, 0);
          });
      });
    },
    loadPreguntasPorTema({ commit }, numeroTema) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      const preguntas = [];
      db.collection("tests")
        .where("numeroTema", "==", numeroTema)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("preguntas"));
            doc.ref
              .collection("preguntas")
              .get()
              .then((preguntaSnap) => {
                preguntaSnap.forEach((item) => {
                  console.log(item.data());
                  let pregunta = item.data();
                  pregunta.id = item.id;
                  if (pregunta.shuffle) {
                    pregunta.respuestas = pregunta.respuestas
                      .map((a) => ({ sort: Math.random(), value: a }))
                      .sort((a, b) => a.sort - b.sort)
                      .map((a) => a.value);
                  }
                  preguntas.push(pregunta);
                });
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setPreguntas", preguntas);
    },
    loadPreguntasPorTemaExamen({ commit }, { numeroTema, numeroPreguntas }) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");
      console.log("loadPreguntasPorTemaExamen");
      const preguntas = [];
      db.collection("tests")
        .where("numeroTema", "==", numeroTema)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("preguntas"));
            doc.ref
              .collection("preguntas")
              .get()
              .then((preguntaSnap) => {
                preguntaSnap.forEach((item) => {
                  console.log(item.data());
                  let pregunta = item.data();
                  pregunta.id = item.id;
                  if (pregunta.shuffle) {
                    pregunta.respuestas = pregunta.respuestas
                      .map((a) => ({ sort: Math.random(), value: a }))
                      .sort((a, b) => a.sort - b.sort)
                      .map((a) => a.value);
                  }
                  preguntas.push(pregunta);
                });
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setPreguntas", preguntas);
    },
    async loadPreguntasPorTemas(
      { commit },
      { temasSelected, numeroPreguntas }
    ) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      console.log("loadPreguntasPorTemas");
      console.log("numeroPreguntas " + numeroPreguntas);

      var porcentajeTotal = 0;

      for (const tema of temasSelected) {
        const temasRef = db.collection("temas").where("numeroTema", "==", tema);
        const temas = await temasRef.get();
        for (const doc of temas.docs) {
          porcentajeTotal += doc.data().porcentaje;
          console.log(doc.data().porcentaje);
        }
      }

      console.log("Porcentaje total");
      console.log(porcentajeTotal);

      const preguntasPorTema = numeroPreguntas / temasSelected.length;
      console.log("numeroPreguntasPorTema " + preguntasPorTema);
      const preguntas = [];
      for (const tema of temasSelected) {
        const testsRef = db.collection("tests").where("numeroTema", "==", tema);

        const tests = await testsRef.get();
        // console.log(tests)
        // const preguntasPorTest = Math.ceil(preguntasPorTema) / tests.docs.length;

        for (const doc of tests.docs) {
          console.log("id tema " + doc.id);
          const porcentajePorTema =
            (100 * doc.data().porcentaje) / porcentajeTotal;
          console.log("Porcentaje por tema " + porcentajePorTema);
          const preguntasPorTema = (porcentajePorTema / 100) * numeroPreguntas;
          const preguntasPorTest = preguntasPorTema / tests.docs.length;

          console.log("preguntasPorTest " + Math.ceil(preguntasPorTest));
          // console.log(doc);
          // console.log(doc.ref.collection("preguntas"));
          const preguntasRef = doc.ref.collection("preguntas");
          const preguntasDoc = await preguntasRef.get();
          const shuffledPreguntasTest = preguntasDoc.docs.sort(
            () => 0.5 - Math.random()
          );
          console.log("shuffledPreguntasTest");
          console.log(shuffledPreguntasTest);
          // const preguntasTest = shuffledPreguntasTest.docs.slice(0,Math.ceil(preguntasPorTest));

          for (const item of shuffledPreguntasTest) {
            let pregunta = item.data();
            pregunta.id = item.id;
            if (pregunta.shuffle) {
              pregunta.respuestas = pregunta.respuestas
                .map((a) => ({ sort: Math.random(), value: a }))
                .sort((a, b) => a.sort - b.sort)
                .map((a) => a.value);
            }
            preguntas.push(pregunta);
          }
        }
      }

      // const testsRef = db
      //   .collection("tests")
      //   .where("numeroTema", "in", temasSelected);
      // const tests = await testsRef.get();
      // for (const doc of tests.docs) {
      //   console.log("id tema " + doc.id);
      //   console.log(doc);
      //   console.log(doc.ref.collection("preguntas"));
      //   const preguntasRef = doc.ref.collection("preguntas");
      //   const preguntasDoc = await preguntasRef.get();
      //   for (const item of preguntasDoc.docs) {
      //     let pregunta = item.data();
      //     pregunta.id = item.id;
      //     if (pregunta.shuffle) {
      //       pregunta.respuestas = pregunta.respuestas
      //         .map((a) => ({ sort: Math.random(), value: a }))
      //         .sort((a, b) => a.sort - b.sort)
      //         .map((a) => a.value);
      //     }
      //     preguntas.push(pregunta);
      //   }
      // }

      setTimeout(() => {
        commit("cargarFirebase", false);
      }, 0);

      const shuffled = preguntas.sort(() => 0.5 - Math.random());

      commit("setPreguntas", shuffled.slice(0, numeroPreguntas));

      // commit("setPreguntas", preguntas);
    },

    async loadPreguntasPorTemasNoVale(
      { commit },
      { temasSelected, numeroPreguntas }
    ) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      console.log("loadPreguntasPorTemas");
      console.log("numeroPreguntas " + numeroPreguntas);

      const preguntas = [];
      await temasSelected.forEach(async (numeroTema) => {
        console.log("NumeroTema");
        console.log(numeroTema);
        await db
          .collection("tests")
          .where("numeroTema", "==", numeroTema)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              console.log("id tema " + doc.id);
              console.log(doc);
              console.log(doc.ref.collection("preguntas"));
              doc.ref
                .collection("preguntas")
                .get()
                .then((preguntaSnap) => {
                  preguntaSnap.forEach((item) => {
                    // if (this.state.preguntas.length == numeroPreguntas) {
                    //   console.log("dentro if limite preguntas");
                    //   return;
                    // }
                    console.log("pregunta ");
                    console.log(item.data());
                    let pregunta = item.data();
                    pregunta.id = item.id;
                    if (pregunta.shuffle) {
                      pregunta.respuestas = pregunta.respuestas
                        .map((a) => ({ sort: Math.random(), value: a }))
                        .sort((a, b) => a.sort - b.sort)
                        .map((a) => a.value);
                    }
                    preguntas.push(pregunta);

                    commit("addPreguntaRandom", pregunta);
                  });
                });
            });
            setTimeout(() => {
              commit("cargarFirebase", false);
            }, 0);
          });
      });
    },

    shufflePreguntasAction({ commit }, data) {
      commit("");
    },

    async editTema({ commit }, data) {
      commit("cargarFirebase", true);

      db.collection("temas")
        .doc(data.numeroTema)
        .set(data)
        .then((doc) => {
          console.log(doc);
        });

      var testsRef = db.collection("tests");

      var query = testsRef.where("numeroTema", "==", data.numeroTema);

      query.get().then(async (snapshot) => {
        snapshot.forEach(async (doc) => {
          console.log(doc.ref);
          console.log(doc.data());
          const res = await doc.ref.update({ porcentaje: data.porcentaje });
          console.log("resultado update tema");
          console.log(res);
        });
        setTimeout(() => {
          commit("cargarFirebase", false);
        }, 0);
      });
    },

    editTest({ commit }, data) {
      commit("cargarFirebase", true);

      db.collection("tests")
        .doc(data.id)
        .set(data)
        .then((doc) => {
          console.log(doc);
          commit("cargarFirebase", false);
        });
    },

    editPregunta({ commit }, { pregunta, test }) {
      commit("cargarFirebase", true);

      console.log("EditPregunta dentro Store ");
      console.log(pregunta);
      console.log(test);
      db.collection("tests")
        .doc(test.id)
        .collection("preguntas")
        .doc(pregunta.id)
        .set(pregunta)
        .then((doc) => {
          console.log(doc);
          commit("cargarFirebase", false);
        });
    },

    async saveNoticia({ commit }, data) {
      commit("cargarFirebase", true);

      console.log("dentroStore");
      console.log(data);
      db.collection("noticias")
        .doc()
        .set(data)
        .then((doc) => {
          // router.push({name: 'home'})
          console.log(doc);
          commit("addNoticia", data);
          commit("cargarFirebase", false);
        });
      // const usuario = firebase.auth().currentUser

      /*  var docRef = db.collection("noticias").doc(data.numeroTema);

      docRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            commit("setExist", true);
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            db.collection("temas")
              .doc(data.numeroTema)
              .set(data)
              .then((doc) => {
                // router.push({name: 'home'})
                console.log(doc);
                commit("addTema", data);
              });
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        }); */
    },

    async saveTema({ commit }, data) {
      commit("cargarFirebase", true);

      console.log("dentroStore");
      console.log(data);

      // const usuario = firebase.auth().currentUser

      var docRef = db.collection("temas").doc(data.numeroTema);

      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            commit("setExist", true);
            commit("cargarFirebase", false);
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
            db.collection("temas")
              .doc(data.numeroTema)
              .set(data)
              .then((doc) => {
                // router.push({name: 'home'})
                console.log(doc);
                commit("addTema", data);
                commit("cargarFirebase", false);
              });
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    async saveTest({ commit }, data) {
      commit("cargarFirebase", true);

      // const usuario = firebase.auth().currentUser
      db.collection("tests")
        .where("numeroTest", "==", data.numeroTest)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            commit("setExist", true);
            commit("cargarFirebase", false);
          } else {
            db.collection("tests")
              .doc()
              .set(data)
              .then((doc) => {
                // router.push({name: 'home'})
                console.log(doc);
                commit("addTest", data);
                commit("cargarFirebase", false);
              });
          }
        });
    },
    async saveTestIncompleted({ commit }, data) {
      commit("cargarFirebase", true);

      // const usuario = firebase.auth().currentUser

      if (data.id == null) {
        db.collection("usuario")
          .where("uid", "==", this.state.usuario.uid)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              console.log("id" + doc.id);
              console.log(doc);
              console.log(doc.ref.collection("tests"));
              doc.ref
                .collection("tests")
                .doc()
                .set(data)
                .then((doc) => {
                  // router.push({name: 'home'})
                  console.log(doc);
                  commit("addTestIncompleted", data);
                  commit("cargarFirebase", false);
                  router.push({ name: "home" });
                });
            });
          });
      } else {
        db.collection("usuario")
          .where("uid", "==", this.state.usuario.uid)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              console.log("id" + doc.id);
              console.log(doc);
              console.log(doc.ref.collection("tests"));
              doc.ref
                .collection("tests")
                .doc(data.id)
                .set(data)
                .then((doc) => {
                  // router.push({name: 'home'})
                  console.log(doc);
                  commit("addTestIncompleted", data);
                  commit("cargarFirebase", false);
                  router.push({ name: "home" });
                });
            });
          });
      }
    },

    loadTestsIncompleted({ commit }) {
      commit("cargarFirebase", true);

      const testsIncompleted = [];

      if (this.state.usuario.uid == null) {
        return;
      }

      db.collection("usuario")
        .where("uid", "==", this.state.usuario.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("tests"));
            doc.ref
              .collection("tests")
              .get()
              .then((snapshot) => {
                snapshot.forEach((doc) => {
                  console.log("id testIncompleted " + doc.id);
                  console.log(doc.data());
                  let test = doc.data();
                  test.id = doc.id;
                  testsIncompleted.push(test);
                });
                setTimeout(() => {
                  commit("cargarFirebase", false);
                }, 0);
              });
          });
        });

      commit("setTestsIncompleted", testsIncompleted);
    },

    loadTestIncompleted({ commit }, idTestIncompleted) {
      commit("cargarFirebase", true);
      commit("setClearPreguntas");

      db.collection("usuario")
        .where("uid", "==", this.state.usuario.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("tests"));
            doc.ref
              .collection("tests")
              .doc(idTestIncompleted)
              .get()
              .then((testIncompleted) => {
                testIncompleted.forEach((item) => {
                  console.log(item.data());
                  let testIncompleted = item.data();
                  pregunta.id = item.id;
                  if (pregunta.shuffle) {
                    pregunta.respuestas = pregunta.respuestas
                      .map((a) => ({ sort: Math.random(), value: a }))
                      .sort((a, b) => a.sort - b.sort)
                      .map((a) => a.value);
                  }
                  preguntas.push(pregunta);
                });
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });

      commit("setPreguntas", preguntas);
    },

    async savePregunta({ commit }, data) {
      console.log("savePreguntas");
      console.log(data);
      db.collection("tests")
        .where("numeroTest", "==", data.numeroTest)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("preguntas"));
            doc.ref
              .collection("preguntas")
              .doc()
              .set(data)
              .then((doc) => {
                // router.push({name: 'home'})
                console.log(doc);
                commit("addPregunta", data);
              });
          });
        });
    },

    async deleteTema({ commit }, tema) {
      db.collection("tests")
        .where("numeroTema", "==", tema.numeroTema)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log(doc);
            doc.ref.delete();
          });
        });

      db.collection("temas")
        .doc(tema.id)
        .delete()
        .then(function () {
          console.log("Document successfully deleted!");
          commit("deleteTemaMutate", tema.numeroTema);
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },
    async deleteTest({ commit }, test) {
      console.log("test.id");
      console.log(test.id);
      db.collection("tests")
        .doc(test.id)
        .delete()
        .then(function () {
          console.log("Document successfully deleted!");
          commit("deleteTestMutate", test.id);
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },

    async deleteTestIncompleted({ commit }, idTestIncompleted) {
      console.log("testIncompleted.id");
      console.log(idTestIncompleted);

      db.collection("usuario")
        .where("uid", "==", this.state.usuario.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            console.log("id" + doc.id);
            console.log(doc);
            console.log(doc.ref.collection("tests"));
            doc.ref
              .collection("tests")
              .doc(idTestIncompleted)
              .delete()
              .then(function () {
                console.log("Document successfully deleted!");
                commit("deleteTestIncompletedMutate", idTestIncompleted);
              })
              .catch(function (error) {
                console.error("Error removing document: ", error);
              });
          });
          setTimeout(() => {
            commit("cargarFirebase", false);
          }, 0);
        });
    },
    async deleteNoticia({ commit }, noticia) {
      console.log("noticia.id");
      console.log(noticia);
      db.collection("noticias")
        .doc(noticia)
        .delete()
        .then(function () {
          console.log("Document successfully deleted!");
          commit("deleteNoticiaMutate", noticia);
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },
   
    
    

    async deleteReport({ commit }, report) {
      console.log("report.id");
      console.log(report);
      db.collection("reportes")
        .doc(report)
        .delete()
        .then(function () {
          console.log("Report successfully deleted!");
          commit("deleteReportMutate", report);
        })
        .catch(function (error) {
          console.error("Error removing document: ", error);
        });
    },

    async deletePregunta({ commit }, { pregunta, test }) {
      console.log("EditPregunta dentro Store ");
      console.log(pregunta);
      console.log(test);
      db.collection("tests")
        .doc(test.id)
        .collection("preguntas")
        .doc(pregunta.id)
        .delete()
        .then((doc) => {
          commit("deletePreguntaMutate", pregunta.id);
          console.log(doc);
        });
    },

    buscador({ commit, state }, payload) {
      state.texto = payload.toLowerCase();
      console.log("prueba buscador : " + state.texto);
    },
  },
  getters: {
    arrayFiltrado(state) {
      let arrayFiltrado = [];

      for (let cliente of state.clientes) {
        let nombre = cliente.nombre.toLowerCase();
        // console.log(nombre.indexOf(state.texto));
        // console.log("nombre: " + nombre)
        // console.log("state.texto" + state.texto)
        if (nombre.indexOf(state.texto) >= 0) {
          // console.log("Dentro del if");
          arrayFiltrado.push(cliente);
        }
      }
      return arrayFiltrado;
    },
    arrayFiltradoEntradas(state) {
      let arrayFiltrado = [];

      for (let entrada of state.entradas) {
        let asunto = entrada.asunto.toLowerCase();
        // console.log(nombre.indexOf(state.texto));
        // console.log("nombre: " + nombre)
        // console.log("state.texto" + state.texto)
        if (asunto.indexOf(state.texto) >= 0) {
          // console.log("Dentro del if");
          arrayFiltrado.push(entrada);
        }
      }
      return arrayFiltrado;
    },
    arrayFiltradoPreguntas(state) {
      let arrayFiltrado = [];

      for (let pregunta of state.preguntas) {
        let titulo = pregunta.pregunta.toLowerCase();
        // console.log(nombre.indexOf(state.texto));
        // console.log("nombre: " + nombre)
        // console.log("state.texto" + state.texto)
        if (titulo.indexOf(state.texto) >= 0) {
          // console.log("Dentro del if");
          arrayFiltrado.push(pregunta);
        }
      }
      return arrayFiltrado;
    },
    existeUsuario(state) {
      if (
        state.usuario === null ||
        state.usuario === "" ||
        state.usuario === undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
});
